var CONFUSEDCMS = CONFUSEDCMS || {};

(function ($) {

    CONFUSEDCMS.tabs = function () {

        var tabs = $(".cms-tabs__tab-list"),
            tabItem = tabs.find("li"),
            tabItems = tabItem.length,
            tabsLink = tabs.find("a"),
            contentPanel = $(".cms-tabs__content__panel"),
            activeClass = ("active");


        tabs.addClass("cms-tabs__tab-list--" + tabItems + "-col");

        tabsLink.click(function () {
            var tabNumber = $(this).attr("data-tab");
            tabsLink.removeClass(activeClass);
            $(this).addClass(activeClass);

            contentPanel.removeClass(activeClass);
            $("#tab-" + tabNumber).addClass(activeClass);

            return false;
        });

    }; 
})(window.jQuery);